module.exports = __webpack_public_path__ + "static/media/consigment.ccd21848.svg";